/**
 * Lead TL;DR helper — extracted from `LeadPage.tsx` so it can be unit-tested
 * directly (it was previously a private function inside the page component).
 *
 * Picks the first readable sentence/paragraph out of agent-written prose for
 * the Hero's one-line summary: strips markdown emphasis, takes the first
 * paragraph, and — if it's long — cuts at a sentence/clause boundary so the
 * TL;DR never ends mid-word.
 */
export function firstSentence(text: string): string {
  if (!text) return "";
  const plain = text.replace(/\*\*/g, "").replace(/\*/g, "").trim();
  const para = plain.split(/\n{2,}/)[0] ?? plain;
  if (para.length <= 240) return para;
  const cut = para.slice(0, 240);
  const lastBoundary = Math.max(cut.lastIndexOf(". "), cut.lastIndexOf(", "));
  return (lastBoundary > 80 ? cut.slice(0, lastBoundary + 1) : cut) + "…";
}
